import React from 'react'
import { Banner } from './banner'

export const Careers = () => {
  return (
    <Banner />
  )
}
